module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Emma-Skating-640.eaa920fc.jpg";